import React from 'react';

import Template from './list_component.rt';
import { login, loginWithGoogle, checkIfLoggedIn } from "../../util/login";
import { isValidValue } from "../../util/pure_functions/utils";

export default class ListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.loginProviders = {
      'facebook': 'clientSide',
      'google': 'clientSide',
      'twitter': 'serverSide',
      'linkedin': 'serverSide'
    };
   }

  signIn(provider) {
    switch (provider) {
    case 'facebook':
      login(null, {sso: this.props.redirect, userLogin: this.props.userLogin});
      break;
    case 'google':
      loginWithGoogle(null,{sso: this.props.redirect, userLogin: this.props.userLogin});
      break;
    case 'twitter':
    case 'linkedin':
      break;
    }
  }

  actBasedOnLoginMessage(loginWindow, e) {
    if(e.data.loggedIn){
      loginWindow.close();
      if(isValidValue(e.data.redirectURI)){
        window.location.href = e.data.redirectURI;
      } else {
        checkIfLoggedIn({userLogin: this.props.userLogin});
      }
    }
    this.removeEventListener();
  }

  removeEventListener() {
    window.removeEventListener("message", this.actBasedOnLoginMessage)
  }

  clickOnServerSideLogin(provider) {
    const loginWindow = window.open(`/login/${provider}?server_side_login=true`, `${provider}Login`);
    window.addEventListener("message", this.actBasedOnLoginMessage.bind(this, loginWindow) , false);
  }

  render() {
    return Template.call(this);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/metype_home/list_component.js